import { addDoc, arrayUnion, collection, doc, getDoc, getDocs, query, updateDoc, where } from "firebase/firestore";
import { db } from "./firebase"
// import {compare, genSalt, hash} from "bcryptjs";

export const addUser = async(newUser)=>{
    try{
        // const salt = await genSalt(10);
        // const hashedPassword = await hash(newUser.pass, salt);
        // newUser.pass = hashedPassword;
        const usersRef = collection(db, "users");
        const docRef = await addDoc(usersRef, newUser);
        return docRef.id ? true : false;
    } catch(err){
        console.error("Error adding user: ", err);
        throw new Error("Failed to add user to Firestore: " + err.message);
    }
}

export const findUser = async(user)=>{
    try{
        const usersRef = collection(db, "users");
        const q = query(
            usersRef,
            where("name", "==", user.name.toLowerCase()),
            where("pass", "==", user.pass),
        );
        console.log(user);
        const querySnapshot = await getDocs(q);

        if(querySnapshot.empty){
            console.log("No matching user found");
            return null;
        }
        const docSnap = querySnapshot.docs[0];
        const _user = { id: docSnap.id, ...docSnap.data() };
        console.log(_user);
        return _user;

        // const plainTextPassword = user.pass;

        // for (const docSnap of querySnapshot.docs) {
        //     const userData = docSnap.data();
        //     const storedHashedPassword = userData.pass;

        //     // Use compare() to check the plain-text password against the stored hash.
        //     const isMatch = await compare(plainTextPassword, storedHashedPassword);
            
        //     if (isMatch) {
        //         console.log(`Login successful for user: ${userData.name}`);
        //         const _user = { id: docSnap.id, ...userData };
        //         delete _user.pass;
        //         return _user;
        //     }
        // }
    } catch(err){
        console.error("Error search user: ", err);
        throw new Error("Failed to find user on firestore: " + err.message);
    }
}

export const addTask = async(userID, newTask)=>{
    try{
        await updateDoc(doc(db, "users", userID),{
            "tasks": arrayUnion(newTask)
        })
        await new Promise(resolve => setTimeout(resolve, 1000));
        return true;
    } catch(err){
        console.error("Error adding task: ",err);
        return false;
    }
}

export const updateTaskStatus = async(userID, taskID, updatedStatus)=>{
    try{
        const userRef = doc(db, "users", userID);
        const userSnap = await getDoc(userRef);

        if (!userSnap.exists()) {
            console.error("User not found");
            return false;
        }

        const userData = userSnap.data();
        const tasks = userData.tasks || [];

        // Map through tasks and update the right one
        const updatedTasks = tasks.map(task =>
            task.id === taskID ? { ...task, status: updatedStatus } : task
        );

        await updateDoc(userRef, { tasks: updatedTasks });
        return true;
    } catch(err){
        console.error("Error updating task: ",err);
        return false;
    }
}

function shortenDate(dateStr) {
  if (!dateStr) return "";

  // Split off the time part
  const [datePart] = dateStr.split(" - "); // gives "08/10/2025"
  
  // Split into parts and shorten the year
  const [day, month, year] = datePart.split("/");

  // Return shortened year (last two digits)
  return `${day}/${month}/${year.slice(-2)}`;
}

export const startNewDay = async(userID, dateTime)=>{
    try{
        const userRef = doc(db, "users", userID);
        const userSnap = await getDoc(userRef);

        if (!userSnap.exists()) {
            console.error("User not found");
            return false;
        }

        const userData = userSnap.data();
        const tasks = userData.tasks || [];

        const todayData = {
            date: shortenDate(dateTime),
            data: tasks
        }

        // Build the new tasks array
        const updatedTasks = tasks
        .filter(task => task.constancy === true) // keep only constant ones
        .map(task => ({
            ...task,
            status: true // reset status to be active
        }));

        // Update Firestore document
        await updateDoc(userRef, { tasks: updatedTasks, history: arrayUnion(todayData) });

        console.log("✅ Tasks have been reset successfully");
        return true;
    } catch(err){
        console.error("Error on starting new day: ",err);
        return false;
    }
}
